import React from 'react';

const Header = () => {
    return (
        <div className='header text-white py-5'>
            <h1>Employee Directory</h1>
        </div>
    )

}

export default Header;